//////////////////////// USER SELECTORS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\
export const selectUser = state => state.user.profile;
export const selectUserId = state => state.user.profile && state.user.profile.uid;
export const selectLoggedInUserID = selectUserId;
export const selectUserToken = state => state.user.profile.token;
export const isLoggedInUser = state => !!state.user.profile;
export const isAuthPending = state => state.user.profile === undefined;
export const isLoggedOutUser = state => state.user.profile === null;
export const selectIsSSRUser = state => state.user.isSSRUser;

export const isAdmin = state => state.user.profile && state.user.profile.isAdmin;

//////////////////////// POST SELECTORS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\
export const selectCurrentPostId = state => state.posts.current._id;

export const isPostOpen = state => !!state.posts.current._id;

//////////////////////// ROUTE SELECTORS \\\\\\\\\\\\\\\\\\\\\\\\\\\\\
export const selectCurrentRoute = state => state.router.route;



// WEBPACK FOOTER //
// ./src/util/selectors.js